import React from 'react';
import {Text, IconTooltip, FlexColumn, FlexRow} from '@forecast-it/design-system';

export function TimeExceedsEstimateInfo(): JSX.Element {
	return (
		<div>
			<Text size={'2'}>Based on your company settings, time entries on a task cannot exceed the estimate.</Text>
			<Text size={'2'} color={'medium'}>
				This is a company-wide setting configured by your admin.
			</Text>
		</div>
	);
}

export function TimeExceedsEstimateIcon(): JSX.Element {
	return (
		<IconTooltip icon={'info'} color={'disabled'} iconSize={'s'}>
			<TimeExceedsEstimateInfo />
		</IconTooltip>
	);
}

type RemainingTimeAndErrorProps = {
	remainingInfoMessage?: string | null;
	timeError?: string | null;
	textSize?: '1' | '2';
	gap?: string;
	marginTop?: string;
	marginBottom?: string;
};

export function RemainingTimeAndError({
	remainingInfoMessage,
	timeError,
	textSize,
	gap,
	marginTop,
	marginBottom,
}: RemainingTimeAndErrorProps): JSX.Element | null {
	return remainingInfoMessage || timeError ? (
		<div style={{marginTop: marginTop || '4px', marginBottom: marginBottom || '12px'}}>
			<FlexColumn gap={gap || 's'}>
				{remainingInfoMessage ? (
					<FlexRow gap={'s'}>
						<Text size={textSize || '2'} color={'medium'}>
							{remainingInfoMessage}
						</Text>
						<TimeExceedsEstimateIcon />
					</FlexRow>
				) : null}
				{timeError ? (
					<Text size={textSize || '2'} color={'error'}>
						{timeError}
					</Text>
				) : null}
			</FlexColumn>
		</div>
	) : null;
}
